import PlusIcon from 'components/icons/PlusIcon';
import {
  Section,
  Container,
  Card,
  IconContainer,
  Content,
  Title,
  Description,
  Button,
  ButtonWrapper,
  ButtonInner,
} from './styles/FeaturesCard.styles';
import { ReactComponent as BatchUpload } from 'static/icons/Batch-upload.svg';
import { ReactComponent as Envelope } from 'static/icons/envelope-icon.svg';
import { ReactComponent as Italian } from 'static/icons/italian-icon.svg';

const features = [
  {
    id: 1,
    icon: BatchUpload,
    title: 'Batch Uploads',
    description: 'Generate multiple scripts/books at once to slash your reading list in one swoop.'
  },
  {
    id: 2,
    icon: Envelope,
    title: 'Coverage submission via email',
    description: 'Submit coverage by emailing your file to our coverage email, and you’ll receive an emailed copy back.'
  },
  {
    id: 3,
    icon: Italian,
    title: 'Multi-language output',
    description: 'Receive your coverage in 14 different languages.'
  }
];

export default function FeatureCards() {
  return (
    <Section>
      <Container>
        {features.map((feature) => {
          const IconComponent = feature.icon;
          return (
            <Card key={feature.id}>
              <IconContainer>
                <IconComponent />
              </IconContainer>
              <Content>
                <Title>{feature.title}</Title>
                <Description>{feature.description}</Description>
              </Content>
            </Card>
          );
        })}
      </Container>
    </Section>
  );
}
